import React from "react";
import styled from "styled-components";
import MiniCard from "../MiniCard";
import Play from "../../assets/img/play.png";
import { useState } from "react";
import ReactPlayer from "react-player";
import AnimatedShapes from "../AnimatedShapes";

const Container = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  @media only screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    align-items: center;
  }
`;
const Left = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const Video = styled.div`
  display: flex;
  justify-content: center;
  /* height: 300px; */
  position: absolute;
  /* top: 0;
  bottom: 0;
  right: 0; */
  margin-top: 100px;
  padding-left: 40px;

  @media only screen and (max-width: 480px) {
    width: 90%;
    position: absolute;
  }
`;
const Right = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 480px) {
    width: 100%;
  }
`;
const Wrapper = styled.div`
  padding: 50px;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 480px) {
    padding: 20px;
    width: 70%;
  }
`;
const Title = styled.h1`
  @media only screen and (max-width: 480px) {
    text-align: center;
  }
`;
const Desc = styled.div`
  font-size: 20px;
  margin-top: 20px;
  color: #555;
  @media only screen and (max-width: 480px) {
    font-size: 15px;
    width: 100%;
  }
`;
const Button = styled.button`
  color: white;
  border: none;
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: bold;
  padding: 15px;
  text-align: center;
  background-color: darkblue;
  margin-top: 50px;
  align-items: center;
  cursor: pointer;
  display: flex;
  width: 200px;
  letter-spacing: 2px;
  &:hover {
    background-color: blue;
  }
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;
const ButtonRes = styled.button`
  color: white;
  border: none;
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: bold;
  padding: 15px;
  text-align: center;
  background-color: darkblue;
  margin-top: 50px;
  align-items: center;
  cursor: pointer;
  display: flex;
  width: 200px;
  letter-spacing: 2px;
  &:hover {
    background-color: blue;
  }
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  @media only screen and (max-width: 480px) {
    justify-content: center;
  }
`;

const Icon = styled.img`
  margin-right: 10px;
  width: 20px;
`;

const Modal = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  @media only screen and (max-width: 480px) {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  background-color: white;
  padding: 5px;
  border: none;
  border-radius: 5px;
  right: 5px;
  top: 30%;
  @media only screen and (max-width: 480px) {
    position: absolute;
    top: 120px;
  }
`;

const LinkRel = styled.a`
  text-decoration: none;
  color: white;
`;

const Offres = () => {
  const [open, setOpen] = useState(false);
  const smallScreen = window.screen.width <= 480 ? true : false;
  return (
    <Container id="Offres">
      <Left>
        <Video>
          <ReactPlayer
            width="600px"
            height="450px"
            controls
            url="https://www.youtube.com/watch?v=P1L3FkBzPWI"
          />
        </Video>
      </Left>
      <Right>
        <Wrapper>
          <Title>Simple process to start</Title>
          <Desc>
            We provide digital experience services to startups and small
            businesses to looking for a partner of their digital media, design &
            development, lead generation and communications requirents. We work
            with you, not for you. Although we have a great resources
          </Desc>
          <CardContainer>
            <MiniCard desc="Design & development." />
            <MiniCard desc="Digital Marketing" />
            <MiniCard desc="Communication" />
          </CardContainer>
          {smallScreen && (
            <ButtonRes onClick={() => setOpen(true)}>
              <Icon src={Play} />
              How it Works
            </ButtonRes>
          )}
          <Button>
            <Icon src={Play} />
            <LinkRel href="https://www.youtube.com/watch?v=P1L3FkBzPWI">
              How it Works
            </LinkRel>
          </Button>
        </Wrapper>
      </Right>
      {smallScreen && open && (
        <Modal>
          <Video>
            <ReactPlayer
              width="90%"
              height="75%"
              open={open}
              controls
              url="https://www.youtube.com/watch?v=P1L3FkBzPWI"
            />
          </Video>
          <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>
        </Modal>
      )}
      <AnimatedShapes />
    </Container>
  );
};

export default Offres;
